import { Grid, styled as muiStyled } from '@mui/material'
import Select from 'react-select'

export const GenericTimerSettingsGridContainer = muiStyled(Grid)(
  ({ theme }) => `    
`,
)

export const GenericTimerSettingsContainer = muiStyled('div')(
  ({ theme }) => `
    background: #ffffff29;
    color: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
    font-size: 1rem;
    border-radius: 6px;
    margin-top: 5px;
    padding: 30px 22px;
    @media(min-width: 768px){
      margin-top: 25px;
    }
  `,
)

export const GenericTimerReactSelectStyled = muiStyled(Select)(
  ({ theme }) => `
  .react-select__control {
    background: #fff5f52e;
  }
  .react-select__placeholder {
    color: white;
  }
`,
)

export const GenericTimerHtmlSelectStyled = muiStyled('select')(
  ({ theme }) => `
  width: 100%;
outline: none;
padding: 10px;
background: #ffffff2e;
border-radius: 7px;
width: 100%;
-webkit-appearance: none;
-moz-appearance: none;
text-indent: 1px;
text-overflow: '';
`,
)
export const GenericTimerHtmlSelectOptionStyled = muiStyled('option')(
  ({ theme }) => `
outline: none;
padding: 10px;
background: #292929;
color: #fff;
border-radius: 7px;
width: 100%;
-webkit-appearance: none;
-moz-appearance: none;
text-indent: 1px;
text-overflow: '';
`,
)
